export default "__VITE_ASSET__XTqSB588__"